enum TipoPacienteEnum {
  MenorDe12 = 'MenorDe12',
  RecemNascido = 'RecemNascido',
  Estrangeiro = 'Estrangeiro',
}

export default TipoPacienteEnum
